import StoreIcon from '@material-ui/icons/Store';
import IconCard from "components-lib/IconCard/IconCard";
import React from "react";
import { injectIntl } from "react-intl";
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import { pathOr } from "rambda";

const DetailLocationsCard = (props) => {
    const {
        data,
        intl,
        internal
    } = props;

    let locations = pathOr([], ['campaign', 'criteria', [0], 'locations'], data).map(item => ( <p>{item.name}</p>))
    let companies = pathOr([], ['campaign', 'criteria', [0], 'companies'], data).map(item => (<p>{item.name}</p>))
    let segments = pathOr([], ['campaign', 'criteria', [0], 'segments'], data).map(item => (<p>{item.name}</p>))
    let zones = pathOr([], ['campaign', 'criteria', [0], 'zones'], data).map(item => (<p>{item.name}</p>))
    let locationsCount = pathOr('', ['campaign', 'criteria', [0], 'match', 'locationsCount' ], data)
    let segmentsCount = pathOr('', ['campaign', 'criteria', [0], 'match', 'segmentsCount' ], data)
    let companiesCount = pathOr('', ['campaign', 'criteria', [0], 'match', 'companiesCount' ], data)
    let zonesCount = pathOr('', ['campaign', 'criteria', [0], 'match', 'zonesCount' ], data)
    console.log( locations )
    console.log( companies )
    console.log( segments )
    console.log( zones )
    console.log( locationsCount )
    console.log( segmentsCount )
    console.log( companiesCount )
    console.log( zonesCount )
    console.log( locations.length > 0 )
    console.log( data )
    return <>
        <IconCard
            title={intl.formatMessage({ id: 'campaigns.targetingCard.title' })}
            icon={<StoreIcon />}
            className= "detailLocations"
        >

            <TableContainer>
                <Table aria-label="simple table">
                    <TableHead>
                        <TableRow>
                            <TableCell>#</TableCell>
                            <TableCell>{intl.formatMessage({ id: 'campaigns.locationsCard.locations' })}</TableCell>
                            <TableCell>{intl.formatMessage({ id: 'campaigns.locationsCard.segments' })}</TableCell>
                            {!internal && <TableCell>{intl.formatMessage({ id: 'campaigns.locationsCard.companies' })}</TableCell>}
                            <TableCell>{intl.formatMessage({ id: 'campaigns.locationsCard.stores' })}</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        <TableRow >
                            <TableCell><b>{intl.formatMessage({ id: 'campaigns.locationsCard.table.name' })}</b></TableCell>
                            <TableCell>{(locations.length > 0) ? locations : intl.formatMessage({ id: 'campaigns.locationsCard.all' })}</TableCell>
                            <TableCell>{(segments.length > 0) ? segments : intl.formatMessage({ id: 'campaigns.locationsCard.all' })}</TableCell>
                            {!internal && <TableCell>{(companies.length > 0) ? companies : intl.formatMessage({ id: 'campaigns.locationsCard.all' })}</TableCell>}
                            <TableCell>{(zones.length > 0) ? zones : intl.formatMessage({ id: 'campaigns.locationsCard.all' })}</TableCell>
                        </TableRow>
                        <TableRow >
                            <TableCell><b>{intl.formatMessage({ id: 'campaigns.locationsCard.table.count' })}</b></TableCell>
                            <TableCell>{(locationsCount) ? locationsCount : "0"}</TableCell>
                            <TableCell>{(segmentsCount) ? segmentsCount : "0"}</TableCell>
                            {!internal && <TableCell>{(companiesCount) ? companiesCount : "0"}</TableCell>}
                            <TableCell>{(zonesCount) ? zonesCount : "0"}</TableCell>
                        </TableRow>

                    </TableBody>
                </Table>
            </TableContainer>
        </IconCard>
    </>
};

export default injectIntl(DetailLocationsCard);
